// Self-hosted, original brand illustrations for the app.
//
// Previously this file hotlinked Unsplash photos. It now references inline SVG
// brand illustrations (see ./illustrations) so there are no third-party image
// requests, licences, or attribution obligations.

import { ILLUSTRATIONS as I } from './illustrations';

const IMAGES = {
  // Hero banner
  hero: I.hero,

  // Welcome modal slides
  welcome: [I.welcomeParent, I.welcomeOutdoor, I.welcomeFriends],

  // Login modal background
  loginBg: I.loginBg,

  // Empty states
  emptyStates: {
    posts: I.emptyPosts,
    events: I.emptyEvents,
    bookings: I.emptyBookings,
    resources: I.emptyResources,
  },

  // Category fallback images for events/walks
  categories: {
    meetup: I.meetup,
    yoga: I.yoga,
    workshop: I.workshop,
    sensory: I.sensory,
    music: I.music,
    playgroup: I.playgroup,
    walk: I.walk,
    storytime: I.storytime,
    swimming: I.swimming,
    coffeegroup: I.coffee,
    default: I.brand,
  },
};

export default IMAGES;
